module.exports = __webpack_public_path__ + "static/img/IMG_20160820_185544.1f6192b0.jpg";